// extracted by mini-css-extract-plugin
export default {"content":"series-rss-content_content__g5gKA"};